export const darkOverrides = {
	'mainSeriesProperties.areaStyle.color1': '#0B335E',
	'mainSeriesProperties.areaStyle.color2': '#0C1B2E',
	'mainSeriesProperties.areaStyle.linecolor': '#71AAE5',
	'mainSeriesProperties.areaStyle.linewidth': 1,
	'mainSeriesProperties.areaStyle.priceSource': 'close',
	'mainSeriesProperties.barStyle.barColorsOnPrevClose': false,
	'mainSeriesProperties.barStyle.dontDrawOpen': false,
	'mainSeriesProperties.barStyle.downColor': '#DD4041',
	'mainSeriesProperties.barStyle.upColor': '#30985B',
	'mainSeriesProperties.candleStyle.downColor': '#DD4041',
	'mainSeriesProperties.candleStyle.upColor': '#30985B',
	'mainSeriesProperties.haStyle.downColor': '#DD4041',
	'mainSeriesProperties.haStyle.upColor': '#30985B',
	'mainSeriesProperties.hollowCandleStyle.downColor': '#DD4041',
	'mainSeriesProperties.hollowCandleStyle.upColor': '#30985B',
	'mainSeriesProperties.style': 1,
	'paneProperties.background': '#101011',
	'paneProperties.horzGridProperties.color': '#2F323C',
	'paneProperties.vertGridProperties.color': '#2F323C',
	'scalesProperties.lineColor': '#FFFFFF',
	'scalesProperties.textColor': '#FFFFFF',
	'symbolWatermarkProperties.color': '#FFFFFF',
	'volumePaneSize': 'tiny'
}

export const lightOverrides = {
	'mainSeriesProperties.areaStyle.color1': '#2F323C',
	'mainSeriesProperties.areaStyle.color2': '#2F323C',
	'mainSeriesProperties.areaStyle.linecolor': '#2F323C',
	'mainSeriesProperties.areaStyle.linewidth': 1,
	'mainSeriesProperties.areaStyle.priceSource': 'close',
	'mainSeriesProperties.barStyle.barColorsOnPrevClose': false,
	'mainSeriesProperties.barStyle.dontDrawOpen': false,
	'mainSeriesProperties.barStyle.downColor': '#FF6370',
	'mainSeriesProperties.barStyle.upColor': '#49B073',
	'mainSeriesProperties.candleStyle.downColor': '#FF6370',
	'mainSeriesProperties.candleStyle.upColor': '#49B073',
	'mainSeriesProperties.haStyle.downColor': '#FF6370',
	'mainSeriesProperties.haStyle.upColor': '#49B073',
	'mainSeriesProperties.hollowCandleStyle.downColor': '#FF6370',
	'mainSeriesProperties.hollowCandleStyle.upColor': '#49B073',
	'mainSeriesProperties.style': 1,
	'paneProperties.background': '#FFFFFF',
	'paneProperties.horzGridProperties.color': '#F6F7F9',
	'paneProperties.vertGridProperties.color': '#F6F7F9',
	'scalesProperties.lineColor': '#EEEEEE',
	'scalesProperties.textColor': '#DDDDDD',
	'symbolWatermarkProperties.color': '#FFFFFF',
	'volumePaneSize': 'tiny'
}
